/* bl-clearance.js — v2.9b. Drives the clearance grid through Shopify storefront facets, no page reload.
   Pills / price chips / filter panel / sort all build a URL with the same filter.* params Shopify's own
   filters use, push it to history, fetch this section via the Section Rendering API (?section_id=)
   and swap the markup in. v2.11: filters live in an inline panel under the toolbar (no drawer). Search is client-side over the loaded cards (loads every page first).
   Re-initialises on shopify:section:load so the theme editor stays live. */
(function () {
  'use strict';
  var SEL = '[data-cl-deals]';

  function init(root) {
    if (!root || root.__clInit) return;
    root.__clInit = true;
    var sid = root.getAttribute('data-section-id');
    var base = root.getAttribute('data-url') || location.pathname;
    var defaultSort = root.getAttribute('data-default-sort') || '';
    var q = '';
    var allLoaded = false;
    var loadingAll = null;
    var aborter = null;
    var debounce = null;
    var lastOpener = null;
    var mem = { open: [], scroll: 0, focus: null };

    function $(s, el) { return (el || root).querySelector(s); }
    function $$(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }

    /* ---- URL state ---- */
    function facetParams(src) {
      var out = new URLSearchParams();
      src.forEach(function (v, k) { if (k === 'sort_by' && (v === '' || v === defaultSort)) return; if ((k.indexOf('filter.') === 0 || k === 'sort_by') && v !== '') out.append(k, v); });
      return out;
    }
    function current() { return facetParams(new URLSearchParams(location.search)); }
    function urlFor(params) { var qs = params.toString(); return base + (qs ? '?' + qs : ''); }

    function go(params, opts) {
      opts = opts || {};
      var url = urlFor(params);
      if (!opts.replace) history.pushState({ cl: true }, '', url);
      root.setAttribute('data-cl-loading', '');
      if (aborter) aborter.abort();
      aborter = new AbortController();
      return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid), { signal: aborter.signal, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) { swap(html); root.removeAttribute('data-cl-loading'); })
        .catch(function (e) { if (e && e.name === 'AbortError') return; root.removeAttribute('data-cl-loading'); location.href = url; });
    }

    /* ---- swap section markup, keep panel + search state ---- */
    function remember() {
      mem.open = $$('[data-facet][open]').map(function (d) { return d.getAttribute('data-facet'); });
      var a = document.activeElement;
      mem.focus = (a && root.contains(a) && a.name) ? { name: a.name, value: a.value, type: a.type } : null;
    }
    function restore() {
      if (mem.open.length) {
        $$('[data-facet]').forEach(function (d) { if (mem.open.indexOf(d.getAttribute('data-facet')) > -1) d.setAttribute('open', ''); });
      }
      if (mem.focus) {
        var el = $$('[name]').filter(function (i) { return i.name === mem.focus.name && (i.type !== 'checkbox' || i.value === mem.focus.value); })[0];
        if (el) { try { el.focus({ preventScroll: true }); } catch (_) { el.focus(); } }
      }
    }
    function swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector(SEL);
      if (!fresh) { location.reload(); return; }
      var wasOpen = root.classList.contains('is-panel-open');
      remember();
      $('[data-cl-body]').innerHTML = $('[data-cl-body]', fresh).innerHTML;
      allLoaded = false; loadingAll = null;
      if (wasOpen) { var d = $('[data-cl-panel]'); if (d) d.hidden = false; $$('[data-cl-toggle-panel]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); }
      restore();
      stickyTop();
      moreBusy = false; watchMore();
      if (q) { var inp = $('[data-cl-search]'); if (inp) inp.value = q; loadAll().then(runSearch); }
    }

    /* ---- inline filter panel (expands under the toolbar; nothing modal) ---- */
    function setPanel(open) {
      var d = $('[data-cl-panel]'); if (!d) return;
      d.hidden = !open;
      root.classList.toggle('is-panel-open', open);
      $$('[data-cl-toggle-panel]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        // the desktop toolbar is sticky: if the user opened the panel after scrolling, the panel sits above the viewport — bring toolbar + panel into view
        var tb = $('[data-cl-toolbar]'); var hdr = parseInt(getComputedStyle(root).getPropertyValue('--cl-sticky-top'), 10) || 0;
        if (tb) {
          stickyTop(); hdr = parseInt(getComputedStyle(root).getPropertyValue('--cl-sticky-top'), 10) || 0;
          var panelTop = d.getBoundingClientRect().top + window.pageYOffset; var want = panelTop - tb.offsetHeight - hdr - 8;
          if (d.getBoundingClientRect().top < hdr + tb.offsetHeight) { var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; window.scrollTo({ top: Math.max(0, want), behavior: reduce ? 'auto' : 'smooth' }); }
        }
        var first = $('[data-cl-panel] input:not([type=hidden]), [data-cl-panel] summary'); if (first) { try { first.focus({ preventScroll: true }); } catch (_) {} }
      } else if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
    }
    function togglePanel(btn) { var d = $('[data-cl-panel]'); if (!d) return; lastOpener = btn; setPanel(d.hidden); }

    /* ---- load more / load all ---- */
    function appendPage(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-cl-grid]'), fresh = doc.querySelector('[data-cl-grid]');
      if (!grid || !fresh) return 0;
      var n = 0;
      $$('[data-cl-card]', fresh).forEach(function (c) { var img = c.querySelector('img'); if (img) img.loading = 'lazy'; grid.appendChild(c); n++; });
      grid.setAttribute('data-page', fresh.getAttribute('data-page'));
      var more = $('[data-cl-more]'), freshMore = doc.querySelector('[data-cl-more]');
      if (more) { if (freshMore) more.replaceWith(freshMore); else more.remove(); }
      var shown = $('[data-cl-shown]'); if (shown) shown.textContent = String($$('[data-cl-card]').length);
      return n;
    }
    var moreBusy = false, moreIO = null;
    function loadMore(a) {
      var href = a.getAttribute('href'); if (!href || moreBusy) return;
      moreBusy = true;
      var wrap = a.closest('[data-cl-more]'); if (wrap) wrap.setAttribute('data-cl-busy', '');
      a.setAttribute('aria-busy', 'true'); a.textContent = 'Loading…';
      var u = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
      fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function (html) {
        appendPage(html);
        var grid = $('[data-cl-grid]');
        if (grid && +grid.getAttribute('data-page') >= +grid.getAttribute('data-pages')) allLoaded = true;
        moreBusy = false; watchMore();
        if (q) runSearch();
      }).catch(function () { moreBusy = false; location.href = href; });
    }
    /* auto-load: when the sentinel (the Load-more block) comes within ~700px of the viewport, fetch the next page */
    function watchMore() {
      if (moreIO) { moreIO.disconnect(); moreIO = null; }
      var m = $('[data-cl-more][data-cl-auto]'); if (!m || !('IntersectionObserver' in window)) return;
      moreIO = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        if (q) return; // searching: pages are loaded by loadAll
        var a = $('[data-cl-more-btn]'); if (a && !moreBusy) loadMore(a);
      }, { rootMargin: '0px 0px 700px 0px' });
      moreIO.observe(m);
    }
    function loadAll() {
      if (allLoaded) return Promise.resolve();
      if (loadingAll) return loadingAll;
      var grid = $('[data-cl-grid]'); if (!grid) return Promise.resolve();
      var page = +grid.getAttribute('data-page') || 1, pages = +grid.getAttribute('data-pages') || 1;
      if (page >= pages) { allLoaded = true; return Promise.resolve(); }
      var params = current();
      var jobs = [];
      for (var p = page + 1; p <= pages; p++) {
        (function (pp) {
          var ps = new URLSearchParams(params.toString()); ps.set('page', String(pp)); ps.set('section_id', sid);
          jobs.push(fetch(base + '?' + ps.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }));
        })(p);
      }
      var countEl = $('[data-cl-count]'); if (countEl) countEl.setAttribute('data-busy', '');
      loadingAll = Promise.all(jobs).then(function (pagesHtml) {
        pagesHtml.forEach(appendPage);
        var more = $('[data-cl-more]'); if (more) more.remove();
        grid.setAttribute('data-page', String(pages));
        allLoaded = true;
        if (countEl) countEl.removeAttribute('data-busy');
      }).catch(function () { loadingAll = null; if (countEl) countEl.removeAttribute('data-busy'); });
      return loadingAll;
    }

    /* ---- search (client-side over loaded cards) ---- */
    function runSearch() {
      var cards = $$('[data-cl-card]'), grid = $('[data-cl-grid]'), empty = $('[data-cl-empty-search]');
      var countEl = $('[data-cl-count]'), nounEl = $('[data-cl-noun]'), more = $('[data-cl-more]');
      var words = q.split(/\s+/).filter(Boolean);
      var n = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (words.length) { var hay = (c.getAttribute('data-search') || '').toLowerCase(); for (var i = 0; i < words.length; i++) { if (hay.indexOf(words[i]) === -1) { ok = false; break; } } }
        c.hidden = !ok; if (ok) n++;
      });
      if (words.length) {
        if (countEl) countEl.textContent = String(n);
        if (nounEl) nounEl.textContent = n === 1 ? 'match' : 'matches';
        if (more) more.hidden = true;
        if (empty) empty.hidden = n > 0;
        if (grid) grid.hidden = n === 0;
      } else {
        var total = grid ? grid.getAttribute('data-total') : String(n);
        if (countEl) countEl.textContent = total;
        if (nounEl) nounEl.textContent = total === '1' ? 'product' : 'products';
        if (more) more.hidden = false;
        if (empty) empty.hidden = true;
        if (grid) grid.hidden = total === '0';
      }
    }
    function onSearchInput(val) {
      q = (val || '').trim().toLowerCase();
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        if (q && !allLoaded) loadAll().then(runSearch); else runSearch();
      }, 220);
    }

    /* ---- sticky toolbar under the theme's sticky header ---- */
    function stickyTop() {
      // bottom edge of whatever the theme keeps pinned at the top (announcement bar + header): the sticky toolbar / panel scroll under it
      var top = 0;
      [].slice.call(document.querySelectorAll('.shopify-section-group-header-group, .header')).forEach(function (el) {
        var pos = getComputedStyle(el).position; if (pos !== 'sticky' && pos !== 'fixed') return;
        var r = el.getBoundingClientRect(); if (r.height > 0 && r.top >= -1 && r.top < 200) top = Math.max(top, r.bottom);
      });
      root.style.setProperty('--cl-sticky-top', Math.round(top) + 'px');
    }

    /* ---- back to top (mobile: toolbar is not sticky, so offer a way back to the filters) ---- */
    var topBtn = $('[data-cl-top]'), topTick = false;
    function topCheck() {
      topTick = false; if (!topBtn) return;
      var tb = $('[data-cl-toolbar]'); if (!tb) return;
      var show = tb.getBoundingClientRect().bottom < 0;
      if (show === !topBtn.hidden) return;
      if (show) { var bar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe'); var bh = bar ? bar.getBoundingClientRect().height : 0; topBtn.style.setProperty('--cl-top-lift', bh > 0 && bh < 200 ? Math.round(bh) + 'px' : '0px'); }
      topBtn.hidden = !show; if (show) topBtn.classList.add('is-in');
    }
    function topGo() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = 0;
      if (topBtn.getAttribute('data-target') !== 'page') {
        var hdr = parseInt(getComputedStyle(root).getPropertyValue('--cl-sticky-top'), 10) || 0;
        y = Math.max(0, root.getBoundingClientRect().top + window.pageYOffset - hdr - 8);
      }
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      var tb = $('[data-cl-toolbar] [data-cl-search]'); if (tb && y > 0) { try { tb.focus({ preventScroll: true }); } catch (_) {} }
    }
    if (topBtn) {
      topBtn.addEventListener('click', topGo);
      window.addEventListener('scroll', function () { if (!topTick) { topTick = true; requestAnimationFrame(topCheck); } }, { passive: true });
      topCheck();
    }

    /* ---- events (delegated, survive swaps) ---- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-cl-tile],[data-cl-price],[data-cl-remove],[data-cl-clear],[data-cl-clear-search],[data-cl-toggle-panel],[data-cl-more-btn]') : null;
      if (!t || !root.contains(t)) return;
      var params;
      if (t.hasAttribute('data-cl-tile')) {
        params = current(); params.delete('filter.p.product_type');
        var types = (t.getAttribute('data-types') || '').split('|').filter(Boolean);
        if (t.getAttribute('aria-pressed') !== 'true') types.forEach(function (v) { params.append('filter.p.product_type', v); });
        go(params);
      } else if (t.hasAttribute('data-cl-price')) {
        params = current(); params.delete('filter.v.price.gte'); params.delete('filter.v.price.lte');
        if (t.getAttribute('aria-pressed') !== 'true') {
          if (t.getAttribute('data-min')) params.set('filter.v.price.gte', t.getAttribute('data-min'));
          if (t.getAttribute('data-max')) params.set('filter.v.price.lte', t.getAttribute('data-max'));
        }
        go(params);
      } else if (t.hasAttribute('data-cl-remove')) {
        if (t.getAttribute('data-param')) { params = current(); params.delete(t.getAttribute('data-param')); go(params); }
        else { var u = new URL(t.getAttribute('data-url'), location.origin); go(facetParams(u.searchParams)); }
      } else if (t.hasAttribute('data-cl-clear')) {
        params = new URLSearchParams(); var sb = current().get('sort_by'); if (sb) params.set('sort_by', sb);
        q = ''; var inp = $('[data-cl-search]'); if (inp) inp.value = '';
        go(params);
      } else if (t.hasAttribute('data-cl-clear-search')) {
        q = ''; var inp2 = $('[data-cl-search]'); if (inp2) { inp2.value = ''; inp2.focus(); } runSearch();
      } else if (t.hasAttribute('data-cl-toggle-panel')) {
        togglePanel(t);
      } else if (t.hasAttribute('data-cl-more-btn')) {
        e.preventDefault(); loadMore(t);
      }
    });
    /* colour swatches on cards (same markup as the theme's product-card; theme.js only binds .product-card, so we do it here) */
    root.addEventListener('click', function (e) {
      var sw = e.target.closest ? e.target.closest('.cl-card .swatch') : null; if (!sw || !root.contains(sw)) return;
      e.preventDefault();
      var card = sw.closest('.cl-card'); if (!card) return;
      $$('.swatch.selected', card).forEach(function (x) { x.classList.remove('selected'); }); sw.classList.add('selected');
      var lab = card.querySelector('.swatch-selected'); if (lab) lab.textContent = sw.getAttribute('data-value') || sw.textContent.trim();
      var img = card.querySelector('[data-cl-img]'), src = sw.getAttribute('data-src');
      if (img && src && img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; }
      var href = sw.getAttribute('href'); if (href) { $$('.cl-card__media, .cl-card__title a', card).forEach(function (a) { a.setAttribute('href', href); }); }
      var pr = parseInt(sw.getAttribute('data-price'), 10), cp = parseInt(sw.getAttribute('data-compare'), 10), now = card.querySelector('.cl-card__now'), was = card.querySelector('.cl-card__was');
      if (now && pr > 0) {
        var fmt = function (c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
        now.textContent = fmt(pr);
        if (was) { if (cp > pr) { was.textContent = fmt(cp); was.hidden = false; } else { was.hidden = true; } }
      }
    });
    root.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches && el.matches('[data-cl-sort]')) {
        var params = current(); if (el.value && el.value !== defaultSort) params.set('sort_by', el.value); else params.delete('sort_by'); go(params);
      } else if (el.form && el.form.hasAttribute('data-cl-form')) {
        if (el.hasAttribute('data-cl-search') || !el.name) return; // the search box lives in the form for layout only: Enter/blur must not refetch the section
        var fd = new FormData(el.form), params2 = new URLSearchParams();
        fd.forEach(function (v, k) { if (String(v).trim() !== '') params2.append(k, String(v).trim()); });
        go(facetParams(params2));
      }
    });
    root.addEventListener('submit', function (e) { if (e.target.hasAttribute('data-cl-form')) e.preventDefault(); });
    root.addEventListener('input', function (e) { if (e.target.hasAttribute('data-cl-search')) onSearchInput(e.target.value); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-panel-open')) setPanel(false); });
    window.addEventListener('popstate', function () { go(current(), { replace: true }); });
    window.addEventListener('resize', stickyTop);
    var stTick = false; window.addEventListener('scroll', function () { if (!stTick) { stTick = true; requestAnimationFrame(function () { stTick = false; stickyTop(); }); } }, { passive: true });
    stickyTop();
    watchMore();
    var inp0 = $('[data-cl-search]'); if (inp0 && inp0.value) onSearchInput(inp0.value);
  }

  function boot() { [].slice.call(document.querySelectorAll(SEL)).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector(SEL); if (r) { r.__clInit = false; init(r); } });
})();
